import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
//@ts-ignore
import { appendQueryString } from "@utils/UrlBuilderUtils";
//@ts-ignore
import { GAutocompleteTypes } from "@customTypes/GAutocompleteTypes";
//@ts-ignore
import { handleAxiosError, baseURL } from "@services/servicesUtils";
//@ts-ignore
var baseController = "".concat(baseURL, "/rest/geography");
var sessionToken = uuidv4();
export var getPlacesAddressAutocomplete = function getPlacesAddressAutocomplete(query, radius) {
  var types = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return __awaiter(void 0, void 0, void 0, function* () {
    if (!sessionToken) sessionToken = uuidv4();
    var url = new URL("".concat(baseController, "/placesAddressAutocomplete"));
    var length = types.length;
    var _types = types.reduce((acc, cur, currentIndex) => {
      if (length === 1) return cur;
      if (currentIndex === length - 1) return acc;
      return acc += "".concat(cur, "|");
    }, "");
    var urlWithQueryString = appendQueryString(url, {
      query,
      radius,
      sessionToken: sessionToken,
      types: _types
    });
    var res = yield axios.get(urlWithQueryString.toString());
    if (res.data.status !== "OK") throw new Error("There was an error in the request");
    return res.data.predictions;
  });
};
export var getPlacesDetails = placeId => __awaiter(void 0, void 0, void 0, function* () {
  if (!sessionToken) sessionToken = uuidv4();
  var url = new URL("".concat(baseController, "/getPlacesDetails"));
  var urlWithQueryString = appendQueryString(url, {
    placeId,
    sessionToken: sessionToken,
    fields: GAutocompleteTypes.PLACE_DETAILS_FIELDS
  });
  var res = yield axios.get(urlWithQueryString.toString());
  sessionToken = "";
  if (res.data.status !== "OK") throw new Error("There was an error in the request");
  return res.data.result;
});
export var guessPlace = (latitude, longitude) => __awaiter(void 0, void 0, void 0, function* () {
  var url = new URL("".concat(baseController, "/guessCityPlace/").concat(latitude, "/").concat(longitude));
  var res = yield axios.get(url.toString());
  return res.data;
});
export var getPlaceFromPlaceID = id => __awaiter(void 0, void 0, void 0, function* () {
  if (id === null || id === undefined) throw new Error("The id can't be null");
  var res = yield axios.get("".concat(baseController, "/getPlaceFromPlaceID/").concat(id));
  return res.data;
});
export var getCountryPolygonJSON = id => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get("https://cdn.wk-cdn.it/files/geo_data/v1/polygonJson/country/".concat(id, ".json"));
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});
export var getRegionPolygonJSON = id => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get("https://cdn.wk-cdn.it/files/geo_data/v1/polygonJson/region/".concat(id, ".json"));
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});
export var getCityPolygonJSON = id => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get("https://cdn.wk-cdn.it/files/geo_data/v1/polygonJson/city/".concat(id, ".json"));
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});
export var getProvincePolygonJSON = id => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get("https://cdn.wk-cdn.it/files/geo_data/v1/polygonJson/province/".concat(id, ".json"));
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});
export var guessZone = (latitude, longitude) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get("".concat(baseController, "/guessZonePlace/") + latitude + "/" + longitude);
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});
//return a string representing the polygon to draw
export var getAroundMePolygon = function getAroundMePolygon(latitude, longitude) {
  var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return axios.get("/rest/geography/buildMapCircleArea?latitude=" + latitude + "&longitude=" + longitude + "&radius=" + radius);
};